import ReactDOM from 'react-dom';
import React, { Component, createRef } from 'react';
import classnames from 'classnames';

import { isAndroid, isHarmony } from '../../../utils/common';
import './index.scss';
// const style = require('./index.less');

/**
 * 模态框管理器
 */
function ModalManager(this: any) {
  let modalItems: Array<Modal> = [];
  let showingModalItems: Array<Modal> = [];

  /**
   * 添加浮层对象
   */
  this.addModal = (modal: Modal) => {
    modalItems.push(modal);
  };

  /**
   * 删除浮层对象
   */
  this.removeModal = (modal: Modal) => {
    const newModalItems: Array<Modal> = [];
    modalItems.forEach((item: Modal) => {
      if (modal.modalId !== item.modalId) newModalItems.push(item);
    });
    modalItems = newModalItems;

    const newShowingModalItems: Array<Modal> = [];
    showingModalItems.forEach((item: Modal) => {
      if (modal.modalId !== item.modalId) newShowingModalItems.push(item);
    });
    showingModalItems = newShowingModalItems;
  };

  /**
   * 显示当前浮层对象
   */
  this.showModal = (modal: Modal) => {
    showingModalItems.push(modal);
    // modalItems.forEach((item) => {
    //   // 隐藏其他弹窗
    //   // item.setVisibility(modal.modalId === item.modalId ? 'visible' : 'hidden');
    // });
    modal.setModalShowingState('opening');
  };

  /**
   * 隐藏当前浮层对象
   */
  this.hideModal = (modal: Modal) => {
    const newItems: Array<Modal> = [];
    modal.setModalShowingState('hiding');
    showingModalItems.forEach((item: Modal) => {
      if (modal.modalId !== item.modalId) newItems.push(item);
    });

    showingModalItems = newItems;
    if (showingModalItems.length > 0) {
      // 恢复显示当前浮层对象
      showingModalItems[showingModalItems.length - 1].setVisibility('visible');
    }
  };

  /**
   * 获取需展示浮层个数
   */
  this.getShowingCount = () => {
    return showingModalItems.length;
  };
}
const modalManager = new ModalManager();

interface PropsType {
  modalClassName?: string;
  children: React.ReactNode,
  isOpened: Boolean,
  position?: 'top' | 'center' | 'bottom',
  isMask?: boolean,
  isLock?: boolean,
  closeOnClickOverlay?: boolean,
  zIndex?: number,
  target?: React.RefObject<HTMLElement>,
  hideOtherModal?: boolean;
  onHide: () => void,
  onShowed: () => void,
  useAnimate: boolean;
}

enum MODAL_STATUS {
  opened = 'opened',
  opening = 'opening',
  hiding = 'hiding',
  hidden = 'hidden',
}

interface StateType {
  height: number,
  visibility: 'visible' | 'hidden',
  modalStatus: 'opened' | 'opening' | 'hiding' | 'hidden';
}

class Modal extends Component<PropsType, StateType> {
  constructor(props: PropsType) {
    super(props);
    this.modalEl = createRef();
    this.state = {
      height: 0,
      visibility: 'visible',
      modalStatus: 'hidden',
    };

    // 加入模态框管理器
    this.modalId = `${Date.now()}_${Math.random()}`;
    modalManager.addModal(this);
  }


  private positionMap = {
    top: 'comp_modal_top',
    center: 'comp_modal_center',
    bottom: 'comp_modal_bottom',
  };

  // eslint-disable-next-line react/static-property-placement
  static defaultProps = {
    position: 'center',
    isMask: true,
    isLock: true,
    zIndex: 999,
    closeOnClickOverlay: true,
    useAnimate: true,
    onShowed: () => {},
    onHide: () => {},
  };

  public modalId: string = '';

  private modalEl: any = null;

  private contentEl: any = null;

  private prePosition: string = ''; // 页面原定位方式

  private scrollTop: number = 0; // 页面原滚动高度

  private containerHeight: number = 0; // 浮层容器高度

  /**
   * 锁定/解锁页面滚动
   */
  private setStyle = (isOpened: Boolean) => {
    const { position } = this.props;
    const showingModalCount = modalManager.getShowingCount();
    if (isOpened) {
      this.setState({
        height: document.documentElement.clientHeight || document.body.clientHeight,
      });
      if (document.body.style.position === 'fixed') {
        const bodyTop = Math.abs(Number(document.body.style.top.replace('px', '')) || 0);
        // 重复弹窗，不设置 top 值 (居中弹窗除外)
        if (position === 'center' || (this.modalEl && this.modalEl.current && showingModalCount === 1)) {
          this.modalEl.current.style.top = `${bodyTop}px`;
        }
        return;
      }
      this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.body.style.top = `-${this.scrollTop}px`;
      if (this.modalEl && this.modalEl.current) {
        this.modalEl.current.style.top = `${this.scrollTop}px`;
      }
    }
    if (!isOpened && showingModalCount === 0) {
      // 重新设置body定位
      // if (modalManager.getShowingCount() === 0) {
      document.body.style.position = this.prePosition || 'static';
      document.body.style.top = '0px';
      document.documentElement.scrollTop = this.scrollTop;
      document.body.scrollTop = this.scrollTop;
      // }
    }
  };

  componentDidMount() {
    const { isOpened, isLock, target } = this.props;
    if (isLock) {
      if (modalManager.getShowingCount() === 0) {
        this.prePosition = document.body.style.position;
      }
      this.setStyle(isOpened);
    }

    if (isOpened) {
      modalManager.showModal(this);
    }

    this.setState({
      modalStatus: isOpened ? 'opening' : 'hidden',
    }, () => {
      // console.log('setState completed', this.state.modalStatus);
    });

    this.setState({
      height: document.documentElement.clientHeight || document.body.clientHeight,
    });

    // 安卓机型，键盘弹出/收起时，重新计算高度
    if (isAndroid() || isHarmony()) {
      window.addEventListener('resize', () => {
        const height = document.documentElement.clientHeight || document.body.clientHeight;
        if (this.containerHeight === height) {
          return;
        }

        // 重新设置高度
        this.containerHeight = height;
        this.setState({
          height,
        });

        // 定位到对应的输入框
        const currentEl = document.activeElement as HTMLElement;
        if (currentEl.tagName.toLowerCase() === 'input') {
          if (target && target.current) {
            const targetEl: HTMLElement = target.current;
            targetEl.scrollTop = currentEl.offsetTop - targetEl.offsetHeight + currentEl.offsetHeight;
          }
        }
      });
    }
  }

  componentDidUpdate(prevProps: PropsType, prevState: StateType) {
    const {
      isOpened, useAnimate, onShowed, onHide,
    } = this.props;
    const { modalStatus } = this.state;
    if (prevProps.isOpened !== isOpened) { // isLock && prevProps.isOpened !== isOpened
      if (isOpened) {
        modalManager.showModal(this);
      } else {
        modalManager.hideModal(this);
      }
      if (!useAnimate) {
        this.setStyle(isOpened);
      }
    }
    // 正在打开  || (prevState.modalStatus === 'hidden' && modalStatus === 'opened')
    if (modalStatus !== prevState.modalStatus && modalStatus === 'opening') {
      this.setStyle(true);
    }
    // 正在关闭
    if (modalStatus !== prevState.modalStatus && modalStatus === 'hiding') {
      this.setStyle(false);
    }

    if (prevState.modalStatus !== modalStatus && modalStatus === 'opened') {
      onShowed();
    }

    if (prevState.modalStatus !== modalStatus && modalStatus === 'hidden') {
      console.log('................... componentDidUpdate onHide', prevState.modalStatus, modalStatus, onHide)
      onHide();
    }
  }

  componentWillUnmount() {
    const { isLock } = this.props;
    modalManager.removeModal(this);
    if (isLock) {
      this.setStyle(false);
    }
  }

  /**
   * 动态添加到页面
   */
  static popup = (properties: any) => {
    const { ...props } = properties || {};
    const div = document.createElement('div');
    document.body.appendChild(div);
    ReactDOM.render(<Modal {...props} />, div);

    return {
      destroy() {
        try {
          ReactDOM.unmountComponentAtNode(div);
          document.body.removeChild(div);
        } catch (err) {
          console.error('destroy modal fail', err);
        }
      },
    };
  };

  /**
   * 设置是否可见
   *
   * @param visibility
   */
  setVisibility = (visibility: 'visible' | 'hidden') => {
    this.setState({
      visibility,
    });
  };

  setModalShowingState = (showingState: 'opened' | 'opening' | 'hiding' | 'hidden') => {
    const { useAnimate = true } = this.props;
    let beforeSetState = showingState;
    const curModalStatus = this.state.modalStatus;
    // 不使用动画，跳过过渡状态
    if (!useAnimate) {
      switch (showingState) {
        case 'opening':
          beforeSetState = 'opened';
          break;
        case 'hiding':
          beforeSetState = 'hidden';
          break;
        default:
          beforeSetState = showingState;
      }
    }

    // 动画中的，直接 return，避免抖动
    if (useAnimate && (curModalStatus === 'opening' || curModalStatus === 'hiding')) {
      return;
    }

    this.setState({
      modalStatus: beforeSetState,
    }, () => {
      if (!useAnimate) return;
      let latestStatus = this.state.modalStatus;
      // delay for animation
      if (latestStatus === 'opening') {
        latestStatus = 'opened';
      } else if (latestStatus === 'hiding') {
        latestStatus = 'hidden';
      }
      if (latestStatus !== this.state.modalStatus) {
        setTimeout(() => {
          this.setState({
            modalStatus: latestStatus,
          });
        }, 350);
      }
    });
  };

  onClosingModal = () => {
    const {
      onHide,
      useAnimate,
    }: PropsType = this.props;
    const { modalStatus } = this.state;
    console.log('onClosingModal modalStatus ??? ', modalStatus);
    if (modalStatus === 'hiding' || modalStatus === 'opening') return;

    modalManager.hideModal(this);

    if (!useAnimate && onHide) {
      onHide();
      return;
    }
    if (onHide) {
      setTimeout(() => {
        onHide();
      }, 350);
    }
  };

  render() {
    const {
      modalClassName = ' ',
      children,
      isOpened,
      position = 'center',
      isMask,
      isLock,
      closeOnClickOverlay,
      zIndex,
      onHide,
      useAnimate,
    }: PropsType = this.props;
    const { height, visibility, modalStatus } = this.state;

    return (
      <React.Fragment>
        {
          ((useAnimate && modalStatus !== 'hidden') || (!useAnimate && isOpened)) && (
            <div
              ref={this.modalEl}
              style={{
                zIndex, height: `${height}px`, visibility, top: `${this.scrollTop}px`,
              }}
              className={
                classnames(`comp__modal ${modalClassName} ${isLock ? 'comp_modal_lockModal ' : 'comp_modal_modal '} ${this.positionMap[position]}`, {
                  comp_modal_mask: isMask,
                  comp_modal_with_animate: useAnimate,
                  comp_modal_state_opening: useAnimate && modalStatus === 'opening',
                  comp_modal_state_opened: useAnimate && modalStatus === 'opened',
                  comp_modal_state_hiding: useAnimate && modalStatus === 'hiding',
                  comp_modal_state_hidden: useAnimate && modalStatus === 'hidden',
                })
              }
              onClick={e => {
                e.stopPropagation();
                if (closeOnClickOverlay) this.onClosingModal();
              }}
            >
              <div ref={this.contentEl} className="comp_modal_content" onClick={e => { e.stopPropagation(); }}>
                {children}
              </div>
            </div>
          )
        }
      </React.Fragment>
    );
  }
}


export default Modal;
